var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContactinst(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#797979"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2647 9.6001H11.5355C10.437 9.6001 9.6001 10.437 9.6001 11.5355V21.2647C9.6001 22.3632 10.437 23.2001 11.5355 23.2001H21.2647C22.3632 23.2001 23.2001 22.3632 23.2001 21.2647V11.5355C23.2001 10.437 22.3632 9.6001 21.2647 9.6001ZM16.4001 20.4801C18.6493 20.4801 20.4801 18.7016 20.4801 16.557C20.4801 16.1909 20.4278 15.7724 20.3232 15.4586H21.4739V21.0032C21.4739 21.2647 21.2647 21.5263 20.9509 21.5263H11.8493C11.5878 21.5263 11.3263 21.317 11.3263 21.0032V15.4063H12.5293C12.4247 15.7724 12.3724 16.1386 12.3724 16.5047C12.3201 18.7016 14.1509 20.4801 16.4001 20.4801ZM16.4001 18.9109C14.9355 18.9109 13.7847 17.7601 13.7847 16.3478C13.7847 14.9355 14.9355 13.7847 16.4001 13.7847C17.8647 13.7847 19.0155 14.9355 19.0155 16.3478C19.0155 17.8124 17.8647 18.9109 16.4001 18.9109ZM21.4216 13.3139C21.4216 13.6278 21.1601 13.8893 20.8463 13.8893H19.3816C19.0678 13.8893 18.8063 13.6278 18.8063 13.3139V11.9016C18.8063 11.5878 19.0678 11.3263 19.3816 11.3263H20.8463C21.1601 11.3263 21.4216 11.5878 21.4216 11.9016V13.3139Z",
    fill: "#E9E9E9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactinst);
export default __webpack_public_path__ + "static/media/contactinst.002df168.svg";
export { ForwardRef as ReactComponent };